/**
 * file : Authentication/Signup.jsx
 * 설명 : 회원 가입
 */

import Logo from "assets/images/logo_pop.png";

import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { AxiosCall, Fnc, Swal } from "common/globals";
import { Spinner } from "components/Common/Componentization";

export default function Signup() {

  document.title = "회원 가입";

  const navigate = useNavigate();
  const [information, setinformation] = useState([]);
  const [dataLoading, setDataLoading] = useState(false);
  const change = (key, val) => { setinformation({ ...information, [key]: val }) }

  const Signup = () => {
    setDataLoading(true)

    const payload = {
      userid: information.id,
      password : information.pw,
      check_password: information.pw_confirmation,
    }

    AxiosCall.post('/signup', payload)
    .then((result) => {
      Swal.SwalAlert('success', '완료', `<div>${result.data.message}</div>`);
      navigate('/')
    }).catch(err => {
      const response = err.response;
      if(response && (response.status === 422 || response.status === 500)) {
        Swal.SwalAlert('error', '오류', `<div>${response.data.message}</div>`);
      }
    }).finally(() => {
      setDataLoading(false)
    })
  }
  
  return (
    <>
      <Spinner show={dataLoading} />
      <div className="auth">
        <div className="write_box input-type mypage_content box_style1">
          <h2><img src={Logo} alt="tmt" /><span>회원가입</span></h2>
          <div className="tit_box">
            <p>아이디</p>
            <input
              type="text"
              placeholder="아이디 입력"
              className="input-type"
              onChange={(e) => {change('id', e.target.value)}}
              onKeyDown={(e) => { Fnc.enterEvent(e, Signup) }}
            />
          </div>
          <div className="tit_box">
            <p>비밀번호</p>
            <input
              type="password"
              placeholder="비밀번호 입력"
              className="input-type"
              onChange={(e) => {change('pw', e.target.value)}}
              onKeyDown={(e) => { Fnc.enterEvent(e, Signup) }}
            />
          </div>
          <div className="tit_box">
            <p>비밀번호 확인</p>
            <input
              type="password"
              placeholder="비밀번호 재입력"
              className="input-type"
              onChange={(e) => {change('pw_confirmation', e.target.value)}}
              onKeyDown={(e) => { Fnc.enterEvent(e, Signup) }}
            />
          </div>
          <div className="btns">
            <Link className="btn_basic bg2" onClick={Signup}>회원가입</Link>
          </div>
        </div>
        <div className="text">
          <p>이미 계정이 존재 하시나요? <Link to="/"> 로그인</Link></p>
        </div>
      </div>
    </>
  )
}